import React, {Component} from 'react';
import {getSubject} from "../services/SubjectService";
import {LearnBox} from "./LearnBox";
import {LearnPage} from "./LearnPage";
import {SubjectButton} from "./SubjectButton";
import {PointsProgress} from "./PointsProgress";
import {ProblemTemplates} from "./ProblemTemplates";

export class Subject extends Component {
    static displayName = Subject.name;

    constructor(props) {
        super(props);
        const subjectKey = window.location.pathname.replace("/subject/", "");
        this.state = {subjectKey: subjectKey, subject: null, loading: true};
    }

    static renderSubject(subject) {
        return (
            <LearnPage title={subject.displayName} backUrl="/" backTitle="Forside">
                <div className="row">
                    <LearnBox>
                        <SubjectButton key={subject.key} url={"/streak/" + subject.key} title="Opgave-stime"
                                       text="Løs så mange opgaver i træk som muligt!"/>
                    </LearnBox>
                    <LearnBox>
                        <SubjectButton key={subject.key} url={"/rush/" + subject.key} title="Opgave-ræs"
                                       text="Løs opgaver på tid!"/>
                    </LearnBox>
                    <LearnBox>
                        <PointsProgress subjectKey={subject.key}/>
                    </LearnBox>
                    <LearnBox title="Træn emner">
                        <p>Træn opgaver inden for et bestemt emne!</p>
                        <SubjectButton key={subject.key} url={"/practice/" + subject.key} text="Blandede opgaver"/>
                        {subject.themes.map(theme =>
                            <SubjectButton key={theme.key} url={"/practice/" + subject.key + "/" + theme.key}
                                           text={theme.displayName}/>
                        )}
                    </LearnBox>
                    <ProblemTemplates subjectKey={subject.key}/>
                </div>
            </LearnPage>
        );
    }

    componentDidMount() {
        this.fetchSubject();
    }

    render() {
        return this.state.loading
            ? <p><em>Loading...</em></p>
            : Subject.renderSubject(this.state.subject);
    }

    fetchSubject() {
        getSubject(this.state.subjectKey).then(subject => {
            this.setState({subject: subject, loading: false});
        });
    }
}